import defaultState from '../data/state';

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_RESPONSE':
      return {
        ...state,
        ...action.newState
      };
    case 'SET_GEO_TYPE':
    //console.log('reducer SET_GEO_TYPE', action, ' and state', state, 'new state')
      return {
        ...state,
        ...action.newState
      };
    case 'SET_POPULATION':
    //console.log('reducer SET_POPULATION', action, ' and state', state)
      return {
        ...state,
        ...action.newState
      }; 
    case 'SET_CATEGORY':
      return {
        ...state,
        ...action.newState
      };  
    case 'SET_DATA_TABLE':
      return {
        ...state,
        ...action.newState
    }; 
    
    case 'SET_GEONAME':
      return {
        ...state,
        ...action.newState
      };
    case 'SET_MAPTYPE':
    //console.log('reducer', action)
      return {
        ...state,
        ...action.newState
      }; 
    case 'SET_MAP_OPACITY':
      //console.log('reducer', action)
        return {
          ...state,
          ...action.newState
        };
    case 'SET_DETAIL_VIEW':
      return {
        ...state,
        ...action.newState
      };
    case 'SET_PROFILE':
      return {
        ...state,
        ...action.newState
      };  
    case 'SET_FORECAST_CATEGORY':
      return {
        ...state,
        ...action.newState
      };  
    case 'SET_FORECAST_TABLE':
      return {
        ...state,
        ...action.newState
      }; 
    case 'SET_YEAR_SLIDER':
    return {
      ...state,
      ...action.newState
    };
    case 'SET_BUSINESS_OVERVIEW':
      return {
        ...state,
        ...action.newState
      };            
    default:
      return state;
  }
};




// WEBPACK FOOTER //
// ./src/reducers/globalState.js